import { Component, ComponentFactoryResolver, Input, OnInit, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { alert } from 'devextreme/ui/dialog';
import { data } from 'jquery';
import { anagraficaData } from '../../class/appinterface';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';


@Component({
  selector: 'app-ana-grid',
  templateUrl: './ana-grid.component.html',
  styleUrls: ['./ana-grid.component.css']
})

export class AnagraficaGridComponent implements OnInit {
  currentElement: any[] = [];
  currentTabId: any;
  currentTabName: any;
  currentParams //conservo i paramentri correnti
  anagraficaDati: any[] = [];
  anagraficaFilter: any[] = [];
  toolbarComponentFilter

  filter: any;
  filterID: any;
  titleDynamic: string;
  breadcrumbCaption: string='';
  service: string;
  componentGrid: string;
  campo: any = {}



  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;
  @Input() api: any
  data: any[] = [];
  queryFilter: any;
  helpDoc: any;

  constructor(

    private activatedroute: ActivatedRoute,
    private router: Router,
    private componentService: ComponentService,
    private templateService: FormsTemplateService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _overlaySideFormService: OverlaySideFormService,
    private _overlaySidePanelService: OverlaySideFormService,
  ) { }




  ngOnInit() {



    this.activatedroute.queryParams

      .subscribe(params => {
        console.log('params-->',params)
        this.currentParams = params //Definisco i paramentri url correnti, per navigazione all'interno dell'anagrafica
        this.api = params.api;
        this.service = params.service;
        this.filterID = params.filter ? JSON.parse(params.filter) : ''
        this.anagraficaDati = this.templateService.getService(this.service);

        if (!this.anagraficaDati) {
          return
        }

        this.anagraficaFilter = this.anagraficaDati.filter(r => r.configuration);
        
        if(params.titolo){
          this.titleDynamic = params.titolo  
        }else{
          this.titleDynamic = this.anagraficaFilter[0]['configuration']['titleGriglia'] + '$' + params.titoloDaPortare;
        }
        
        if(params.breadcrumb){
          this.breadcrumbCaption = params.breadcrumb  
        }else{
          this.breadcrumbCaption = this.anagraficaFilter[0]['configuration']['breadcrumbCaption'];
        }
        
        
        
        if (this.anagraficaFilter[0]['configuration']['helpDoc']) {
          this.helpDoc=this.anagraficaFilter[0]['configuration']['helpDoc']

          
        }



        let id = ''

        if (params.id) {
          id = params.id
        }

        let filterList = this.anagraficaFilter[0]['configuration']['filterList'];

        if (filterList.includes('$')) {

          let data = this.filterID
          if (this.anagraficaFilter[0]['configuration']['idTabRif']) {
            let arrayIdRif = this.anagraficaFilter[0]['configuration']['idTabRif']
            let newItem = ''
            arrayIdRif.forEach(idTab => {
              if (typeof data[idTab['value']] != 'undefined') {
                newItem = data[idTab['value']];
                filterList = filterList.replace('$', newItem);

              }
            });

            //console.log('filterList', filterList)


          }

          //filterList = filterList.replace('$', id)
        }


        this.filter = filterList


        if (params.queryFilter) {
          if (this.anagraficaFilter[0]['configuration']['queryFilter']) {
            let arrayQueryFilter = this.anagraficaFilter[0]['configuration']['queryFilter']

            let newItemQ = ''
            let dataQueryFilter = JSON.parse(params.queryFilter)

            arrayQueryFilter.forEach(idTab => {
              if (typeof dataQueryFilter[idTab['key']] != 'undefined') {
                newItemQ += idTab['key'] + '=' + dataQueryFilter[idTab['key']] + '&';

                //console.log(idTab['key'] + '=' + dataQueryFilter[idTab['key']])
              }
            });

            this.queryFilter = dataQueryFilter

            if (newItemQ) {
              this.filter = this.filter + '?' + newItemQ
            }
          }

        }

        //console.log('filter',this.filter)
        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName

        if (params.data) {

          let data = JSON.parse(params.data)
          if (this.anagraficaFilter[0]['configuration']['idTabRif']) {
            let arrayIdRif = this.anagraficaFilter[0]['configuration']['idTabRif']
            let newItem
            arrayIdRif.forEach(idTab => {
              if (typeof data[idTab['value']] != 'undefined') {
                newItem = { ...this.currentElement, [idTab['key']]: data[idTab['value']] };
                this.currentElement = newItem
              }
            });

            console.log('currentElementNGONINIT', this.currentElement)


          }

        }

        this.toolbarComponentFilter = this.anagraficaFilter[0]['configuration']['toolbarSettings']

        if (this.anagraficaFilter[0]['configuration']['componentGrid'] == 'dynamicGrid') {
          this.componentGrid = 'dynamicComponent';

          if (this.anagraficaFilter[0]['configuration']['idTabRif']) {
            let arrayIdRif = this.anagraficaFilter[0]['configuration']['idTabRif']
            let newItem = ''
            let data = this.filterID
            arrayIdRif.forEach(idTab => {
              if (typeof data[idTab['value']] != 'undefined') {
                newItem = data[idTab['value']];


              }
            });

            this.filterID = newItem


          }


          this.campo = {

            type: 'campoComponent', labelVisible: false, colSpan: "1", dataField: 'AutorizzazioneAreaCer',
            validation: [{
              type: 'required',
              message: "My custom message"
            }],
            colVisible: false,
            width: '100%',
            dynamic: {

              dataSource: 'autorizzazionecer',

              autocomplete: false,
              checkValue: {
                checkValueMessage: '',
                forceInsert: false
              },
              valueExpr: '',
              campoTabRif: 'id', //In edit o in insert sarà sempre l'id che mi verrà restituito dalle API
              displayExpr: 'descrizione',
              caption: "Lista Autorizzazioni EER Zona",
              filter: 'id',

              componentType: 'dynamicGrid',

              enableEditor: true,
              settingGrid: {
                campoTabRif: 'idAutorizzazione', //è il campo di rif. con il quele effettuare le operazioni di insert, edit e delete della griglia.
                masterKey: 'id',
                keyUnique: 'cer',
                mode: 'cell',
                remoteOperations: true,
                hoverStateEnabled: true,
                rowAlternationEnabled: true,
                repaintChangesOnly: true,
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
              }

            }


          }

        } else {
          this.componentGrid = 'nicaAnagrafica'
        }

      });

  }



  AllEvent(e) {

    

    if (e.name == 'onRowPrepared') {
     
      let menuButtonGrid = []
      e.columns.map(col => {
        if (col.type == 'menuToolbar') {
          menuButtonGrid.push(col)
        }

      })

      

    }



    if (e.name == "onEditorPrepared") {
      //return;  

      e.cancel = true;

      
      e.descEvent='Modifica';
     

      
      if (this.anagraficaFilter[0]['configuration']['idTabRif']) {
        let arrayIdRif = this.anagraficaFilter[0]['configuration']['idTabRif']
        let newItem
        arrayIdRif.forEach(idTab => {
          if (typeof e.data[idTab['value']] != 'undefined') {
            newItem = { ...this.currentElement, [idTab['key']]: e.data[idTab['value']] };
            this.currentElement = newItem
          }
        });

      }

      if (this.anagraficaFilter[0]['configuration']['queryFilter']) {
        let arrayQueryFilter = this.anagraficaFilter[0]['configuration']['queryFilter']

        let newItem


      }

      this.nicaAnagrafica.selezionaRiga(e.data.id);

      this.OpenEditor(e);
    }


    if (e.name == "onInitNewRow") {
      e.cancel = true;
      e.descEvent='Inserisci';
      if (this.anagraficaFilter[0]['configuration']['idTabRif']) {
        let arrayIdRif = this.anagraficaFilter[0]['configuration']['idTabRif']
        let newItem
        let data = this.filterID
        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            newItem = { ...this.currentElement, [idTab['key']]: data[idTab['value']] };
            this.currentElement = newItem
          }
        });

      }

      this.OpenEditor(e);
    }

  }


  OpenEditor(e) {

   // console.log(e)

    let config = this.anagraficaDati.filter(res => res.configuration);

    let id = ''
    let titoloDaPortare;
    let keyRif

    if(e.data){
      id=e.data.id;
      
      if(typeof this.anagraficaFilter[0]['configuration']['campoTitle'] != 'undefined'){
        keyRif = this.anagraficaFilter[0]['configuration']['campoTitle']
      }
      
      
      if (typeof keyRif != 'undefined' && typeof e.data[keyRif] != 'undefined') {
        titoloDaPortare = e.data[keyRif]; 
      }else{
        titoloDaPortare = this.currentParams.titoloDaPortare
      }
    }else{
      
      titoloDaPortare = this.currentParams.titoloDaPortare
      
    }
    console.log('titoloDaPortare',titoloDaPortare)
    
   

    let filterEditor = this.anagraficaFilter[0]['configuration']['filterEditor']
    if (filterEditor.includes('$')) {
      filterEditor = filterEditor.replace('$', id);
    }




    let tabsJson = [
      {
        id: this.currentTabId,
        title: this.currentTabName,
        icon: 'user',
        key: 'dash',
        component: "AnaSoggettoComponent",


      }
    ];


    //console.log(this.currentElement)
    let dataToSend = JSON.stringify(this.currentElement)
    let queryFilter = JSON.stringify(this.queryFilter);
    let cUrl = this.router.url.split('?')[0]

    const rUrl = this.router.url.split('?')[0] + '/edit'
    //console.log(dataToSend)
    this.router.navigate(
      [rUrl],
      {
        queryParams:
        {
          id: id,
          prevUrl: this.router.url,
          service: config[0]['configuration']['service'],
          descEvent:e.descEvent,
          titoloDaPortare:titoloDaPortare,
          filter: dataToSend,
          queryFilter: queryFilter,
          data: dataToSend,
          currentTabId: this.currentTabId,
          currentTabName: this.currentTabName,
          componentName: 'AnaSoggettoComponent'
        },
        skipLocationChange: true,
        replaceUrl: false
      }
    ).then(res => {

      /*if (tabsJson) {

        this.componentService.addNewTab('dashboard', tabsJson);
      }*/

      const queryParams = this.currentParams


      this.setCaptionNav(cUrl, queryParams);

    })

  }

  setCaptionNav(cUrl, queryParams) {


    let nav = {
      title: this.breadcrumbCaption,
      cRouter: cUrl,
      params: queryParams,


    }

    this.componentService.setComponentNavigation(nav)


  }

  onRowSelected($event) {

  }

  optionalButtonEvent(em) {

    if (em.infoButton.event == 1) {

      if (!em.infoButton.value) {
        alert('Funzione non disponibile', 'Attenzione!')
        return;
      }
     
      const helpString = em.infoButton.name.replace(/\s/g, '')+'.html';

      const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
      const factoryClass = <Type<any>>factories.find((x: any) => x.name === em.infoButton.value);
      this._overlaySidePanelService.setTitle(em.infoButton.name);
      this._overlaySidePanelService.setContent(factoryClass);
      this._overlaySideFormService.setToolBarVisible(true)
      this._overlaySideFormService.setHelp(helpString)
      this._overlaySideFormService.setPopupWidth((em.wPopUp) ? em.infoButton.wPopUp : 800);
      this._overlaySideFormService.setPopupHeight((em.hPopUp) ? em.infoButton.hPopUp : 500);

      let data = [
        {
          idTabRif: em.datiGriglia.id,
          nomeTabRif: em.infoButton.costantValue,
          dati: em.datiGriglia
        }
      ]
      ////////console.log("EM VALUE I ANA SOGGETTO ",em)
      this._overlaySidePanelService.sendDataToComponent(data);

      this._overlaySidePanelService.show();
    }

    if (em.infoButton.event == 3) {

      let data =
      {
        idTabRif: em.datiGriglia.id,
        service: em.infoButton.dataSource,
        infoButton:em.infoButton,
        dati: em.datiGriglia
      }

      this.routerNavigate(data)

    }

    if (em.infoButton.event == 4) {
      let datajS
      //console.log('datiGriglia',em.datiGriglia)
      if (em.infoButton.costantValue) {
        const costantValue = em.infoButton.costantValue

        costantValue.forEach(res => {
          //console.log(res)
          datajS = {
            ...datajS, [res['key']]: em.datiGriglia[res['value']],


          }
        })

      }



      const navigationParams = {
        id: em.infoButton.dataSource,

        masterKey: 'id',


        data: JSON.stringify(datajS),
        currentTabId: em.infoButton.dataSource,
        currentTabName: em.infoButton.name,
        componentName: em.infoButton.dataSource

      }



      this.router.navigate(
        [em.infoButton.value],
        {
          queryParams: navigationParams,
          skipLocationChange: true,
          replaceUrl: false
        }
      ).then(res => {

      })
    }

    if (em.infoButton == 'grigliaDropDownButtonInit') {
      //console.log('grigliaDropDownButtonInit', em)

      const rowData = em.data
      const buttons = em.buttons;
      const component = em.component
      let newButton = []
      buttons.forEach((button, i) => {

        let filtStato: boolean = false;
        let filtDisabled: boolean = false;
        
        if(button.visible){
          //console.log(button.dataSource)
          filtStato = true
          
        }

        if (this.toolbarComponentFilter) {

          let toolbarFilter = this.toolbarComponentFilter

          
          if (typeof toolbarFilter.displayButtons != 'undefined') {

            toolbarFilter.displayButtons.forEach(too => { 

              
             let arrayCondition = too.condition
             
              
              if (too.name == button.dataSource) {
                let value = too.condition.value
                let conditions = too.condition.key 
                

                let condition = '';
                let checkString = '';
                let operatorEnd = '&&'
                let x=1
                for (var key in conditions) {

                  let operator = x < conditions.length  ? operatorEnd : ''

                  if(typeof rowData[conditions[key]] != 'undefined'){
                    condition +=   String(rowData[conditions[key]])  +'=='+ 'true'  + operator ;
                  }else{
                    let rowDataParams = JSON.parse(this.currentParams['data'])
                   // console.log(rowDataParams)
          
                    condition +=   String(rowDataParams[conditions[key]])  +'=='+ 'true' + operator;
                  }

                  x++

                    

                }
                //console.log(condition)
                if (eval(condition)) {
                  //console.log(condition)
                  filtStato = true
                }
                

               
              }
              
            })





            /*if (toolbarFilter.displayButtons.name == button.value) {
              let value = toolbarFilter.displayButtons.condition.value
              if(typeof rowData[toolbarFilter.displayButtons.condition.key] != 'undefined'){
                if (String(rowData[toolbarFilter.displayButtons.condition.key]) == value) {
                  filtStato = true
                } else {
                  filtStato = false
                }
              }else{
                
                let rowDataParams = JSON.parse(this.currentParams['data'])
                if(typeof rowDataParams[toolbarFilter.displayButtons.condition.key] != 'undefined'){
                  if (String(rowDataParams[toolbarFilter.displayButtons.condition.key]) == value) {
                    filtStato = true
                  } else {
                    filtStato = false
                  }
                }
                
              }

              
              

            }*/
          }
          if (typeof toolbarFilter.disabledButtons != 'undefined') {
            toolbarFilter.disabledButtons.forEach(t => {
              let value = t.condition.value
              let key = t.condition.key
              if (t.name == button.dataSource) {
               
                //console.log(t.condition.key + '--->' + rowData[t.condition.key] + '==' + value)
                if (String(rowData[key]) == value) {
                  filtDisabled = false
                } else {
                  filtDisabled = true
                }
              }else{
                let rowDataParams = JSON.parse(this.currentParams['data'])
                if(typeof rowDataParams[key] != 'undefined'){
                  if (String(rowDataParams[key]) == value) {
                    filtDisabled = false
                  } 
                }
              }
            })


          }

        }

        newButton.push({
          name: button.name,
          icon: button.icon,
          image: '',
          hint: button.name,
          id: i,
          displayMode: button.displayMode,
          event: button.event,
          value: button.value,
          hPopUp: button.hPopUp,
          wPopUp: button.wPopUp,
          costantValue: button.costantValue,
          dataSource: button.dataSource,
          visible: filtStato,
          disabled: filtDisabled,
          items: button.items

        })

      })
      

      if (newButton.length > 0) {
        component.option('items', newButton)
      }
    }
  }

  manipulatedButtonsGrid(item, rowData) {
    return

  }



  routerNavigate(data) {

    if (this.anagraficaFilter[0]['configuration']['idTabRif']) {
      this.currentElement = [];
      let arrayIdRif = this.anagraficaFilter[0]['configuration']['idTabRif']
      let newItem
      arrayIdRif.forEach(idTab => {
        //console.log(idTab['key'], data.dati[idTab['value']])
        if (typeof data.dati[idTab['value']] != 'undefined') {
          newItem = { ...this.currentElement, [idTab['key']]: data.dati[idTab['value']] };
          this.currentElement = newItem
        }
      });

      //console.log('currentElement', this.currentElement)


    }
    


    ////console.log(this.currentElement)
    let dataToSend = JSON.stringify(this.currentElement)
    let titolo
    let id

    //console.log(data.dati)

    

   
    let titoloDaPortare;
    let keyRif

    if(data.dati){
      id=data.dati.id;
      
      if(typeof this.anagraficaFilter[0]['configuration']['campoTitle'] != 'undefined'){
        keyRif = this.anagraficaFilter[0]['configuration']['campoTitle']
      }
      
      
      if (typeof keyRif != 'undefined' && typeof data.dati[keyRif] != 'undefined') {
        titoloDaPortare = data.dati[keyRif]; 
      }
    }else{
      
      titoloDaPortare = this.currentParams.titoloDaPortare
      
    }

    
   

 
    const navigationParams = {
      id: data.idTabRif,
      api: data.service,
      service: data.service,
      masterKey: 'id',
      filter: dataToSend,
       titoloDaPortare:titoloDaPortare,
      data: dataToSend,
      
      currentTabId: this.currentTabId,
      currentTabName: this.currentTabName,
      componentName: 'AnagraficaGridComponent'

    }
    let url = this.router.url.split('?')[0];
    //console.log(url)

    this.router.navigate(['/'], {
      skipLocationChange: true,
      replaceUrl: true
    }).then(() => {
      // Forzo a naviagare verso questa url per aggiornare i dati. 
      //è un pezzoto ma NicaAnagrafica non si aggiorna,
      //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
      let navigationExtras: NavigationExtras = {
        queryParams: navigationParams, skipLocationChange: true,
        replaceUrl: true
      };
      this.router.navigate([url], navigationExtras);

      const queryParams = this.currentParams


      this.setCaptionNav(url, queryParams);
    });




    return
    this.router.navigate(
      [],
      {
        queryParams:
        {
          id: data.idTabRif,
          api: data.service,
          service: data.service,
          masterKey: 'id',
          filter: dataToSend,

          data: dataToSend,
          currentTabId: this.currentTabId,
          currentTabName: this.currentTabName,
          componentName: 'AnagraficaGridComponent'

        },
        relativeTo: this.activatedroute,
        queryParamsHandling: null,
        skipLocationChange: true,
        replaceUrl: false
      }
    ).then(res => {


      if (res) {
        //console.log(res)
        setTimeout(() => {

        }, 400);

        let tabsJson = [
          {
            id: this.currentTabId,
            title: this.currentTabName,
            icon: 'user',
            key: 'dash',
            component: "AnagraficaGridComponent",

          }
        ];

        this.componentService.addNewTab('dashboard', tabsJson);
      }


    })
  }
}
